<template>
  <div id="app">
    <Launch />
  </div>
</template>

<script>
import "mobiotics-dynamic-components-vue/dist/mobiotics_dynamic_components_vue.css";
import { mapActions, mapMutations } from "vuex";
import { mVMixin } from "@/mixins.js";
import { interceptor } from "@/interceptorHub"

export default {
  name: "App",
  data() {
    return {
      subuserList: [],
    };
  },
  components: {
    Launch: () => import("@/components/init/Init.vue"),
  },
  created() {
    this.checkSession();
  },
  mounted() {
    if (localStorage.getItem("token")) {
      let obj = {
        service: "VDRM",
        status: "Active",
      };
      this.subuserList = [{ name: "ALL", id: 1, value: "" }];
      this.actListProvider(obj)
        .then((res) => {
          this.checkTokenExpiry(res);
          if (res.data) {
            obj.pagesize = res.totalcount;
            this.actListProvider(obj).then((res) => {
              if (res.data) {
                this.listData(res.data);
              }
            });
          } else {
            this.listData(null);
          }
        })
        .catch((error) => {
          this.listData(null);
        });
    } else {
      let res = {};
      res.errorcode = 401;
      this.checkTokenExpiry(res);
    }
  },
  mixins: [mVMixin],

  methods: {
    ...mapActions(["actListProvider"]),
    ...mapMutations(["setAuthToken"]),
    checkSession() {
      this.setAuthToken(`Bearer ${localStorage.getItem("token")}`);
      let token;
      if (window.location.search) {
        token = new URLSearchParams(window.location.search);
        localStorage.setItem("token", token.get("token"));
        this.setAuthToken(`Bearer ${localStorage.getItem("token")}`);
      }
    },
    listData(data) {
      let finalArr = [];
      let defaultData = [{ name: "ALL", id: 1, value: "" }];
      let optionValue = [];
      if (data) {
        data.forEach((ele, index) => {
          let obj = {};
          obj.name = `${ele.username}#${ele.provideradminid}`;
          obj.id = index + 2;
          obj.value = ele.provideradminid;
          optionValue.push(obj);
        });
      }
      finalArr = defaultData.concat(optionValue);
      // console.log("finalArr", finalArr);
      this.subuserList = finalArr;
      sessionStorage.setItem("setuserList", JSON.stringify(this.subuserList));
    },
  },
};
</script>

<style lang='scss'>
@import "./scss/_main.scss";

body {
  margin: 0;
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue